import { createSelector } from '@reduxjs/toolkit'

export const getGeneralSummarySlice = (state) => state.generalSummary

export default createSelector([getGeneralSummarySlice], (generalSummary) => ({
    generalSummary,
    generalSummaryStatus: generalSummary.status,
    hasGeneralSummary: !!generalSummary.taxReturnId,
}))
